import React from 'react';
import { useNavigate } from 'react-router-dom';
import  { useState } from 'react';



export default function AiPricing({ priceData }) {

  const navigate = useNavigate();

  const [subscriptionData, setSubscriptionData] = useState({
    plan: '',
    price: 0,
    planID:'',

    // ... other subscription-related data
  });

  const handleSubscriptionSelection  = (selectedPlan) => {
    setSubscriptionData({
      plan: selectedPlan.plan,
      price: selectedPlan.price,
      planID:selectedPlan.planID,
      // ... update other subscription-related data
    });
  };

  console.log("SubcriptionData:",subscriptionData)
  console.log("PriceData:",priceData)

  const handleCheckout = () => {
    // Navigate to the checkout page and pass subscriptionData as state
    navigate('/checkout', { state: { subscriptionData: { ...subscriptionData } } });
  };


  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 bg-slate-50">
  <div className="grid grid-cols-1 gap-6 sm:grid-cols-4 sm:items-center md:gap-8">
  {/* Price Section 1 */}
    <div
      className="rounded-2xl border border-gray-200 p-6 sm:order-last shadow-md sm:px-8 lg:p-12 cursor-pointer bg-white focus:outline-none focus:ring :ring-violet-800"
      
      onClick={() => handleSubscriptionSelection({ plan: 'Basic', price: 10 ,planID:'price_1OfifCSAITWSFpPvGdUfxy4K'})}

    >
      <div className="text-center">
        <h2 className="text-lg font-medium text-gray-900">
          Basic
          <span className="sr-only">Plan</span>
        </h2>

        <p className="mt-2 sm:mt-4">
          <strong className="text-3xl font-bold text-gray-900 sm:text-4xl">
            10$
          </strong>

          <span className="text-sm font-medium text-gray-700">/month</span>
        </p>
      </div>

      <ul className="mt-6 space-y-2 ">
        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700"> 1 Months Access </span>
        </li>

        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700"> AI-Powered Learning </span>
        </li>

        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700"> AI-Assisted Modules </span>
        </li>

        <li className="flex items-center gap-1 " 

        >
          
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700"> Unlimited Mock </span>
        </li>
      </ul>

      <button
            className="mt-8 block mx-auto rounded-full border ring-1 ring-black bg-white px-12 py-3 text-center text-sm font-medium outline-2	 text-black hover:bg-gradient-to-r from-fuchsia-900 to-fuchsia-700 hover:text-white hover:ring-1 hover:ring-purple-900 focus:outline-none focus:ring "
            onClick={handleCheckout}
          >
            1 Month Subscription
          </button>
    </div>
    {/* End */}

    {/* Price Section 2 */}
    <div
      className="rounded-2xl border border-gray-200 p-6 shadow-md sm:px-8 lg:p-12 cursor-pointer bg-white"
      onClick={() => handleSubscriptionSelection({ plan: 'Starter', price: 20, planID:'price_1Ofig4SAITWSFpPvGZE4FNp8' })}

    >
      <div className="text-center">
        <h2 className="text-lg font-medium text-gray-900">
          Starter
          <span className="sr-only">Plan</span>
        </h2>

        <p className="mt-2 sm:mt-4">
          <strong className="text-3xl font-bold text-gray-900 sm:text-4xl">
            20$
          </strong>

          <span className="text-sm font-medium text-gray-700">/month</span>
        </p>
      </div>

      <ul className="mt-6 space-y-2">
        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700"> 3 Months Access </span>
        </li>

        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700"> AI-Powered Learning </span>
        </li>

        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700"> AI-Assisted Modules </span>
        </li>

        <li className="flex items-center gap-1 cursor-pointer"
        onClick={() => handleSubscriptionSelection({ plan: 'Starter', price: 20, planID:'price_1OfiguSAITWSFpPvZVS7rGB7' })}

        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700"> Unlimited Mock </span>
        </li>
      </ul>

      <button
            className="mt-8 block mx-auto rounded-full border ring-1 ring-black bg-white px-12 py-3 text-center text-sm font-medium outline-2	 text-black hover:bg-gradient-to-r from-fuchsia-900 to-fuchsia-700 hover:text-white hover:ring-1 hover:ring-purple-900 focus:outline-none focus:ring "
            onClick={handleCheckout}
          >
            3 Month Subscription
          </button>
    </div>
    {/* End */}

    {/* Price Section 3 */}
    <div
      className="rounded-2xl border  p-6 shadow-md border-purple-900 ring-1 ring-purple-900 sm:px-8 lg:p-16 hover cursor-pointer bg-white"
      onClick={() => handleSubscriptionSelection({ plan: 'Premium', price: 50,planID:'price_1OfiguSAITWSFpPvZVS7rGB7' })}
    >
      <div className="text-center">
        <h2 className="text-lg font-medium text-gray-900">
          Premium
          <span className="sr-only">Plan</span>
        </h2>

        <p className="mt-2 sm:mt-4">
          <strong className="text-3xl font-bold text-gray-900 sm:text-4xl">
            30$
          </strong>

          <span className="text-sm font-medium text-gray-700">/month</span>
        </p>
      </div>
    
      <ul className="mt-6 space-y-2">
        <li className="flex items-center gap-1 "  >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700"> 6 Months Access </span>
        </li>

        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700"> AI-Powered Learning </span>
        </li>

        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700">AI-Assisted Modules  </span>
        </li>

        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700">Unlimited Mock</span>
        </li>
      </ul>

      <button
            className="mt-8 block mx-auto rounded-full border  bg-gray-900 px-12 py-3 text-center text-sm font-medium text-gray-200 hover:ring-1 hover:ring-purple-500 bg-gradient-to-r from-fuchsia-900 to-fuchsia-700"
            onClick={handleCheckout}
          >
            6 Month Subscription
          </button>
    </div>
    {/* End */}

    {/* Pricing Section 4  */}

    <div
      className="rounded-2xl border  p-6 shadow-md border-purple-900 ring-1 ring-purple-900 sm:px-8 lg:p-16 hover cursor-pointer bg-white"
      onClick={() => handleSubscriptionSelection({ plan: priceData.level, price: priceData.price,planID:'price_1OfiguSAITWSFpPvZVS7rGB7' })}
    >
      <div className="text-center">
        <h2 className="text-lg font-medium text-gray-900">
          AI Powered
          <span className="sr-only">Plan</span>
        </h2>
        <h3 className="text-sm font-medium text-gray-600">({priceData.level})</h3>

        <p className="mt-2 sm:mt-4">
          <strong className="text-3xl font-bold text-gray-900 sm:text-4xl">
            {priceData.price}$
          </strong>

          <span className="text-sm font-medium text-gray-700">/month</span>
        </p>
      </div>
    
      <ul className="mt-6 space-y-2">
        <li className="flex items-center gap-1 "  >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700">  {priceData.duration} Months Access </span>
        </li>

        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700"> AI-Powered Learning </span>
        </li>

        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700">AI-Assisted Modules  </span>
        </li>

        <li className="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="h-5 w-5 text-indigo-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <span className="text-gray-700">Unlimited Mock</span>
        </li>
      </ul>

      <button
            className="mt-8 block mx-auto rounded-full border  bg-gray-900 px-8 py-5 text-center text-sm font-medium text-gray-200 hover:ring-1 hover:ring-purple-500 bg-gradient-to-r from-fuchsia-900 to-fuchsia-700"
            onClick={handleCheckout}
          >
            Recommended
          </button>

    </div>

    {/* End */}
  </div>
</div>
  )
}